import React from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { OptionType } from "../../../slices/users/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

interface FilterOption {
  value: string | number;
  label: string;
}

interface FilterSectionProps {
  userStatusData?: OptionType[];
  handleSetFilteredValue: (input: string) => void;
  handleSetFilterByStatus?: (data: OptionType) => void;
  handleChangeSelector?: (selected: any) => void;
  selectedOption?: OptionType | null;
  placeholder?: string;
  secondaryOptions?: FilterOption[];
  selectedSecondaryOption?: FilterOption | null;
  handleChangeSecondarySelector?: (selected: any) => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  handleSetFilteredValue,
  handleChangeSelector,
  handleSetFilterByStatus,
  selectedOption,
  userStatusData,
  placeholder = "Search by first name or last name",
  secondaryOptions,
  selectedSecondaryOption,
  handleChangeSecondarySelector,
}) => {
  return (
    <div
      className={`filter-section${secondaryOptions ? " filter-section--multi" : ""}`}
    >
      <div className="left-section input-container-wrapper">
        <input
          type="text"
          className="search input-control"
          placeholder={placeholder}
          onChange={(e) => handleSetFilteredValue(e.target.value)}
        />

        <FontAwesomeIcon icon={faSearch} className="fa-search" />
      </div>
      {userStatusData && (
        <div className="right-section input-container-wrapper">
          <Select
            value={selectedOption}
            onChange={handleChangeSelector}
            options={userStatusData}
            className="filter-dropdown input-control select-control"
            name="status"
            isSearchable={false}
          />
        </div>
      )}
      {secondaryOptions && (
        <div className="right-section input-container-wrapper">
          <Select
            value={selectedSecondaryOption}
            onChange={handleChangeSecondarySelector}
            options={secondaryOptions}
            className="filter-dropdown input-control select-control"
            name="secondaryFilter"
            isSearchable={false}
          />
        </div>
      )}
    </div>
  );
};

export default FilterSection;
